import React from "react";
import { Col, Row, Button } from "reactstrap";
import Table from "../../../components/Table/Table";
import DetectionFilter from "./DetectionFilter";
import { notificationAction } from "../../../redux/reducers/notification_reducer";
import * as ActionTypes from "../../../redux/actions/types";
import moment from "moment";
import LoadingMask from "../../../components/Loader/LoadingMask";
import ImageModel from "../../../components/image/ImageModel";
import { GrUndo } from "react-icons/gr";
import { RiErrorWarningLine } from "react-icons/ri";
import { connect } from "react-redux";
import { getAllDetectionsList } from "./apiCalls";
import { ignoreUnIgnoreDetection } from "../../student-reports/detection/apiCalls";
import  invalidIcon  from "../../../assets/table/ValidToggleButon.svg";
let dateOne = moment().startOf("day").toDate();
let startDate = moment(dateOne).format("YYYY-MM-DD HH:mm");
let dateTwo = moment()
  .startOf("day")
  .add(23, "hour")
  .add(59, "minute")
  .toDate();
let endDate = moment(dateTwo).format("YYYY-MM-DD HH:mm");
let initialRange = startDate + " / " + endDate;
class StaffDetection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pictureModal: false,
      imageUrl: "",
      person_type: "7",
      paginationData: [],
      toggle: false,
      allChecked: false,
      selectedDateRange: initialRange,
      detectionList: [],
      selectedDetectionFilters: {
        person_number: "",
        person_name: "",
        device: null,
        location: null,
        department: null,
        ignore: null,
      },
      selectedValues: {
        selected_department: { label: "All", value: null },
        selected_branch: { label: "All", value: null },
        selected_device: { label: "All", value: null },
        selected_location: { label: "All", value: null },
        selected_ignore: { label: "All", value: null },
      },
      download: true,
    };
  }

  componentDidMount = async () => {
    await this.props.RecordPerPage(10);
    await this.props.PageNo(1);
    await this.handleFilterDataTableList();
    this.props.SortName("time_stamp");
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.sortname !== this.props.sortname ||
      prevProps.sortby !== this.props.sortby
    ) {
      // this.props.Loading(true)
      this.handleFilterDataTableList();
    }
    if (prevProps.pageno !== this.props.pageno) {
      this.handleFilterDataTableList();
    }
    if (prevProps.recordperpage !== this.props.recordperpage) {
      // this.props.Loading(true);
      this.props.PageNo(1);
      this.handleFilterDataTableList();
    }
  }

  handleDetectionClear = (e) => {
    let startDate = moment().startOf("date").format("YYYY-MM-DD HH:mm");
    let endDate = moment()
      .startOf("date")
      .hours(23)
      .minutes(59, "hour")
      .seconds(59, "min");
    let Range = startDate + " / " + endDate.format("YYYY-MM-DD HH:mm");
    this.props.PageNo(1);
    this.props.RecordPerPage(10);
    this.setState(
      {
        selectedDetectionFilters: {
          person_number: "",
          person_name: "",
        },
        selectedDateRange: Range,
        selectedValues: {
          selected_department: { label: "All", value: null },
          selected_branch: { label: "All", value: null },
          selected_ignore: { label: "All", value: null },
        },
      },
      () => this.handleFilterDataTableList()
    );
    this.props.SortName("time_stamp");
  };

  handleApplyFilter = () => {
    // this.props.Loading(true);
    this.props.PageNo(1);
    this.handleFilterDataTableList();
  };

  handleFilterFieldChange = (e) => {
    const { name, value } = e.target;
    const { selectedDetectionFilters } = this.state;

    if (name === "person_name" || name === "person_number") {
      this.setState({
        selectedDetectionFilters: {
          ...selectedDetectionFilters,
          [name]: value,
        },
      });
    }
  };

  handelDropDownChange = (selectedOption, obj) => {
    const { selectedValues, selectedDetectionFilters } = this.state;
    const { name } = obj;
    if (!selectedOption) {
      let defaultOption = { value: "", label: "All" };
      if (
        obj.name === "department" ||
        obj.name === "device" ||
        obj.name === "location" ||
        obj.name === "ignore"
      ) {
        this.setState({
          selectedValues: {
            ...selectedValues,
            [`selected_${obj.name}`]: defaultOption,
          },
          selectedDetectionFilters: {
            ...selectedDetectionFilters,
            [name]: null,
          },
        });
      }
      return;
    } else if (obj.name === "ignore") {
      this.setState({
        selectedValues: {
          ...selectedValues,
          [`selected_${name}`]: selectedOption,
        },
        selectedDetectionFilters: {
          ...selectedDetectionFilters,
          [name]: selectedOption.value,
        },
      });
    } else {
      this.setState({
        selectedValues: {
          ...selectedValues,
          [`selected_${name}`]: selectedOption,
        },
        selectedDetectionFilters: {
          ...selectedDetectionFilters,
          [name]: selectedOption.id,
        },
      });
    }
  };

  handleExportCsv = () => {
    this.setState({ appLoadingState: true });
    const { person_type, selectedDateRange } = this.state;
    const { person_number, person_name, device, location, department, ignore } =
      this.state.selectedDetectionFilters;
    getAllDetectionsList(
      this.props.recordperpage ? this.props.recordperpage : null,
      this.props.pageno ? this.props.pageno : null,
      this.props.sortname ? this.props.sortname : null,
      this.props.sortby ? this.props.sortby : null,
      person_name ? person_name.replace(/^\s+|\s+$/g, "") : null,
      person_number ? person_number.replace(/^\s+|\s+$/g, "") : null,
      department ? department : null,
      device ? device : null,
      location ? location : null,
      ignore ? ignore : null,
      selectedDateRange ? selectedDateRange : null,
      person_type ? person_type : null,
      this.state.download ? 1 : null
    )
      .then((response) => {
        if (response.code == 200) {
          if (response.data.file_url != null) {
            window.open(response.data.file_url, "_blank");
          }
        }
          this.setState({ appLoadingState: false });
      })
      .catch((error) => console.log("Erorr in getting staffs ", error));
  };
  handleFilterDataTableList = async () => {
    const { person_type, selectedDateRange } = this.state;
    this.setState({ appLoadingState: true });

    const { person_number, person_name, department, device, location, ignore } =
      this.state.selectedDetectionFilters;
    await getAllDetectionsList(
      this.props.recordperpage ? this.props.recordperpage : null,
      this.props.pageno ? this.props.pageno : null,
      this.props.sortname ? this.props.sortname : null,
      this.props.sortby ? this.props.sortby : null,
      person_name ? person_name.replace(/^\s+|\s+$/g, "") : null,
      person_number ? person_number.replace(/^\s+|\s+$/g, "") : null,
      department ? department : null,
      device ? device : null,
      location ? location : null,
      ignore ? ignore : null,
      selectedDateRange ? selectedDateRange : null,
      person_type ? person_type : null
    )
      .then((response) => {
        if (response.code == 200) {
          this.setState({
            detectionList: response.data.dataset,
            paginationData: response.data.pagination,
            appLoadingState: false,
          });
        } else if (response.code != 200) {
          const info = {
            message: response.message,
            status: "error",
          };
          this.props.notificationAction(info);
          this.setState({ appLoadingState: false });
        }
      })
      .catch((error, response) => {
        const info = {
          message: error.message,
          status: "error",
        };

        this.props.notificationAction(info);
      });
  };
  handleDateApply = (event, picker) => {
    let startDate = picker.startDate.format("YYYY-MM-DD HH:mm");
    let endDate = picker.endDate.format("YYYY-MM-DD HH:mm");
    let Range = startDate + " / " + endDate;
    this.setState({
      selectedDateRange: Range,
    });
  };
  handelShowPictureModal = (item) => {
    this.setState({
      pictureModal: item && !this.state.pictureModal,
      imageUrl: item,
    });
  };

  handleTableButtonClick = (item, type) => {
    const { ignored } = item;

      const statusData = {
        detection_id: [item.detection_id],
        ignore: JSON.stringify(!ignored),
      };
      ignoreUnIgnoreDetection({ payload: statusData }).then((response) => {
        if (response.code === 200) {
          const info = {
            message: response.message,
            status: "success",
          };
          this.props.notificationAction(info);
          this.handleFilterDataTableList();
          this.setState({
            allChecked: false,
          });
          return;
        } else if (response.code != 200) {
          const info = {
            message: response.message,
            status: "error",
          };
          this.props.notificationAction(info);
          this.setState({
            allChecked: false,
          });
        }
      });
    
  };
  handleCheckOptionToggle = (item) => {
    if (item != null) {
      this.setState({
        allChecked: false,
        detectionList: this.state.detectionList.map((s) =>
          s.detection_id == item.detection_id
            ? { ...item, Checked: !s.Checked }
            : s
        ),
      });
    } else {
      this.setState({
        allChecked: !this.state.allChecked,
        detectionList: this.state.detectionList.map((s) => ({
          ...s,
          Checked: !this.state.allChecked,
        })),
      });
    }
  };
  handelBulkIgnore = (item) => {
    const listArray = [];
    item.data.map((item) => {
      listArray.push(item.detection_id);
    });
    const statusData = {
      detection_id: listArray,
      ignore: item.status ? item.status : true,
    };
    ignoreUnIgnoreDetection({ payload: statusData }).then((response) => {
      if (response.code === 200) {
        const info = {
          message: response.message,
          status: "success",
        };
        this.props.notificationAction(info);
        this.handleFilterDataTableList();
        this.setState({
          allChecked: false,
        });
        return;
      } else if (response.code != 200) {
        const info = {
          message: response.message,
          status: "error",
        };
        this.props.notificationAction(info);
        this.setState({
          allChecked: false,
        });
      }
    });
  };
  render() {
    let template;
    const boolRfid = process.env.REACT_APP_RFID;
    template = (
      <div>
        <Row>
          {this.state.appLoadingState ? <LoadingMask /> : null}
          <Col md={6} lg={6}></Col>
          <Col md={6} lg={6} />
        </Row>
        <DetectionFilter
          SelectedValues={this.state.selectedValues}
          onDDChange={this.handelDropDownChange}
          selectedDetectionFilters={this.state.selectedDetectionFilters}
          onFilterReset={this.handleDetectionClear}
          onExportCsv={this.handleExportCsv}
          onApply={this.handleDateApply}
          selectedDateRange={this.state.selectedDateRange}
          onFilterFieldChange={this.handleFilterFieldChange}
          onFilterDetection={this.handleApplyFilter}
        />
        <ImageModel
          show={this.state.pictureModal}
          imageUrl={this.state.imageUrl}
          onModalClose={this.handelShowPictureModal}
        />

        <Row>
          <Col className="pr-grid-col" xs={12} lg={12}>
            {this.state.detectionList && this.state.detectionList.length > 0 ? (
              <Table
                data={this.state.detectionList}
                isImageEnabled={true}
                isImageSquare={[true, true]}
                onShowPicture={this.handelShowPictureModal}
                onTableButtonClick={this.handleTableButtonClick}
                onCheckOptionToggle={this.handleCheckOptionToggle}
                isCheckOption={[true, "detection"]}
                allChecked={this.state.allChecked}
                listItemToDisplay={[
                  { name: "Staff", valueField: "person_name" },
                  { name: "Employee #", valueField: "emp_number" },
                  boolRfid && boolRfid === "true"
                    ? { name: "RFID", valueField: "rfid" }
                    : "",
                  { name: "Department", valueField: "department" },
                  { name: "Device", valueField: "device_name" },
                  { name: "Location", valueField: "location_name" },
                  { name: "Date ", valueField: "date" },
                  { name: "Time", valueField: "time" },
                ]}
                paginationData={this.state.paginationData}
                onGettingBulkRecords={this.handelBulkIgnore}
                // buttonsToDisplay={[
                //   {
                //   value :"ShowHide",
                //   buttonLabel: "Report",
                //   outline:"true",
                //   color:"warning",
                //   icon:<RiErrorWarningLine size={20} className="mr-1 mb-1"/>,
                //   Tooltipmessage: "Only report if AI recognition is incorrect"
                // },
                // ]}
                textButtonsToDisplay={[ {
                  value :"ShowHide",
                  buttonLabel: "Report",
                  color:"warning",
                  Tooltipmessage: "Only report if AI recognition is incorrect"
                },
              ]}
              />
            ) : (
              <div className="text-center">
                There is no data available to show
              </div>
            )}
          </Col>
        </Row>
      </div>
    );

    return (
      <div className="">{template} </div>);
  }
}

const actions = (dispatch) => ({
  notificationAction: (message, status) =>
    dispatch(notificationAction(message, status)),
  RecordPerPage: (recordperpage) =>
    dispatch({ type: ActionTypes.RECORDS_PER_PAGE, recordperpage }),
  PageNo: (pageno) => dispatch({ type: ActionTypes.PAGE_NO, pageno }),
  SortName: (sortName) => dispatch({ type: ActionTypes.SORT_NAME, sortName }),
});
const mapStateToProps = (state) => ({
  pageno: state.tab.pageno,
  recordperpage: state.tab.recordperpage,
  sortby: state.tab.sortBy,
  sortname: state.tab.sortName
});

export default connect(mapStateToProps, actions)(StaffDetection);
